import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';

export const ProcessModelsPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-[var(--color-secondary-text)]">{t('process.processModels')}</h1>
        <p className="mt-1 text-sm text-[var(--color-secondary-text)]">
          Model and analyze your business processes
        </p>
      </div>
      
      <EmptyState
        title="Process Models"
        count={0}
        message="No process models created yet. Get started by creating your first process model."
        action={
          <Button disabled>
            Create Process Model
          </Button>
        }
      />
    </div>
  );
}; 


